export default __webpack_public_path__ + "static/media/pinRed.f15260fd.svg";